import type { ConnectorPropertiesSchema } from "shared-ui";

export type MarketingBannerState =
  | { messageKey: "singlePlatform"; platformName: string }
  | { messageKey: "multiplePlatforms"; platformNames: string[]; count: number }
  | null;

export function getMarketingBannerState(connectors: ConnectorPropertiesSchema[]): MarketingBannerState {
  const disconnectedConnectors = connectors.filter((connector) =>
    connector.connections.some((connection) => !connection.isConnected)
  );

  if (disconnectedConnectors.length === 0) {
    return null;
  }

  if (disconnectedConnectors.length === 1) {
    return { messageKey: "singlePlatform", platformName: disconnectedConnectors[0].name };
  }

  return {
    messageKey: "multiplePlatforms",
    platformNames: disconnectedConnectors.map((connector) => connector.name),
    count: disconnectedConnectors.length,
  };
}
